<template>
  <div class="page" v-cloak>
    <!-- 导航 -->
    <van-nav-bar left-arrow fixed title="余额交易记录" style="z-index:99999" id="nav-bar" @click-left="onClickLeft" @click-right="onClickRight">
      <template #right>
        筛选
        <van-icon name="filter-o" color="#ff5000" size="18" />
      </template>
    </van-nav-bar>
    <!-- 列表 -->
    <!-- <div class="list">
      <text-row-balance v-for="(item, index) in list" :balance-data="item" :key="index"></text-row-balance>
    </div> -->

    <!-- 列表 -->
    <div class="list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
        <text-row-balance v-for="(item, index) in list" :balance-data="item" :key="index"></text-row-balance>
      </van-list>
    </div>

    <van-popup v-model="isShow" position="top" :style="{top:'46px' }">
      <h3 class="pop-tips"> <span class="in-text">快捷筛选</span> </h3>
      <div v-for="(ita, idxa) in poplist" :key="idxa" :class="['radio', popIndex == idxa ? 'radio-active' : '']" @click="getPop(idxa, ita)">
        {{ ita.value }}
      </div>
      <h3 class="pop-tips"> <span class="in-text">时间筛选</span> </h3>

      <div class="time-block">
        <div v-if="!startTime" :class="['input-block',isStart == true ? 'bo':'' ]" @click="cancelStart">开始时间</div>
        <div v-if="startTime" class="input-block-a" @click="cancelStart">{{startTime}}</div>
        至
        <div v-if="!endTime" :class="['input-block',isEnd == true ? 'bo':'' ]" @click="cancelEnd">结束时间</div>
        <div v-if="endTime" class="input-block-a" @click="cancelEnd">{{endTime}}</div>
      </div>
      <div class="picker-time" v-if="isStart||isEnd">
        <van-datetime-picker v-if="isStart" v-model="start" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate" :formatter="formatter" @cancel="cancelStart" @confirm="confirmStart" />
        <van-datetime-picker v-if="isEnd" v-model="end" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate" :formatter="formatter" @confirm="confirmEnd" @cancel="cancelEnd" />
      </div>

      <div class="btn-block">
        <div class="btn-left btnC" @click="cancel">取消筛选</div>
        <div class="btn-right btnC" @click="screen">确定筛选</div>
      </div>

    </van-popup>

  </div>
</template>

<script type="text/babel">
import TextRowBalance from "@/components/text-row-balance/text-row-balance.vue";
export default {
  name: 'BalanceLogList',
  components: { TextRowBalance },
  props: {},
  data() {
    return {

      popIndex: -1,
      action: '', //（pay:支出，recharge: 充值，refund: 退款）
      poplist: [
        {
          code: 'pay',
          value: '支出',
        },
        {
          code: 'recharge',
          value: '充值',
        },
        // {
        //   code: 'refund',
        //   value: '退款',: 
        // },
        {
          code: 'time',
          value: '近期一月',
        },
      ],
      list: [],
      isShow: false,

      minDate: new Date(2018, 0, 1),
      maxDate: new Date(2099, 10, 1),
      start: new Date(),
      end: new Date(),
      startTime: '',
      endTime: '',
      isStart: false,
      isEnd: false,

      pageNum: 1,
      pageSize: 10,
      loading: false,
      finished: false,
    }
  },
  watch: {

  },
  created() { },
  mounted() { },
  methods: {
    // formatter(date) {

    //   return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    // },
    getList() {
      let _this = this;
      _this.$get("/points/api/Points/Logs",
        {
          action: _this.action, //
          startTime: _this.startTime, //开始时间
          endTime: _this.endTime, // 结束时间
          Page: _this.pageNum,
          Size: _this.pageSize,
        }).then((res) => {
          // console.log(res.data);
          _this.loading = false; // 加载状态结束

          if (res.data.code == 200) {
            // console.log(res.data.data);
            let lists = res.data.data.records;

            if (lists && lists.length > 0) {

              if (_this.pageNum == 1) {
                _this.list = lists;
              } else {
                _this.list = _this.list.concat(lists);
              }
              _this.pageNum++
              if (lists.length < _this.pageSize) {

                _this.finished = true; // 数据全部加载完成
              }
            } else {
              console.log('444')
              _this.finished = true; // 数据全部加载完成
            }

          } else {
            console.log('555')
            _this.$toast.fail(res.data.message);
            _this.finished = true;
          }
        });
    },

    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    confirmStart() {
      this.startTime = `${this.start.getFullYear()}-${this.doHandleMonth(this.start.getMonth() + 1)}-${this.doHandleMonth(this.start.getDate())}`;
      this.isStart = !this.isStart;
    },
    cancelStart() {
      this.isStart = !this.isStart;
      this.isEnd = false;
    },
    cancelEnd() {
      this.isEnd = !this.isEnd;
      this.isStart = false;
    },
    confirmEnd() {
      this.endTime = `${this.end.getFullYear()}-${this.doHandleMonth(this.end.getMonth() + 1)}-${this.doHandleMonth(this.end.getDate())}`;
      this.isEnd = !this.isEnd;
    },
    getPop(ind, e) {
      let _this = this;
      _this.popIndex = ind;
      if (e.code == 'time') {
        this.startTime = this.getDay(-30)
        this.endTime = this.filterTime()
        this.action = '';
      } else {
        this.action = e.code;
      }
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1)
    },
    // 筛选
    onClickRight() {
      this.isShow = !this.isShow;
      // this.$toast('筛选');
    },
    // 提交
    screen() {
      console.log(this.startTime)
      console.log(this.endTime)

      this.onClickRight()
      this.list = [];
      this.pageNum = 1;
      this.loading = true;
      this.finished = false;
      this.getList()
    },
    // 取消
    cancel() {
      this.popIndex = -1;
      this.action = '';
      this.startTime = '';
      this.endTime = '';
      this.onClickRight()
      this.list = [];
      this.pageNum = 1;
      this.loading = true;
      this.finished = false;
      this.getList()
    },
    //  当前日期30天前的日期
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    // 月 日 时间处理
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    // 当前日期
    filterTime() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f9f9f9;

  .list {
    padding: 0 15px 30px;
  }
}
.pop-tips {
  text-align: left;
  padding: 0 10px;
  position: relative;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 27px;
  color: #454f63;
  letter-spacing: 1px;
  .in-text::after {
    content: "";
    position: absolute;
    width: 3px;
    height: 13px;
    left: 0;
    top: 8px;
    background: #ff5000;
    z-index: 1;
    border-radius: 0 10px 10px 0;
  }
}
.radio {
  min-width: 81px;
  text-align: center;
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 25px;
  color: #666666;
  display: inline-block;
  padding: 1px 5px;
  background: #eeeeee;
  // border-radius: 5px;

  border-radius: 15px;
  margin: 5px 10px;
  border: 1px solid #eeeeee;
}
.radio-active {
  background: rgba(0, 168, 192, 0.1);
  border: 1px solid #03a8c0;
  color: #ff5000;
}
.time-block {
  // position: relative;
  height: 50px;
  width: 100%;
  // border: 1px solid #eee;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 26px;
  color: #cccccc;
  .bo {
    border-bottom: 1px solid #ff5000 !important;
    color: #ff5000;
  }
  .input-block {
    width: 125px;
    height: 50px;
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  .input-block-a {
    width: 125px;
    height: 50px;
    border-bottom: 1px solid #ff5000;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    color: #ff5000;
  }
}
.picker-time {
  margin-top: 20px;
  border: solid 1px #eee;
}
.btn-block {
  // position: absolute;
  // bottom: 10px;
  // left: 0;
  margin-top: 25px;
  width: 100%;
  height: 47px;
  padding: 0 15px;
  background-color: #ffffff;
  border-top: 1px solid #f9f9f9;

  box-shadow: 0px -5px 5px rgba(69, 79, 99, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  .btn-left {
    width: 50%;
    height: 40px;
    background: #ff510093;
    opacity: 1;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-right {
    width: 50%;
    height: 40px;
    background: #ff5000;
    opacity: 1;

    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
.btnC:active {
  background-color: rgba(255, 80, 0, 0.7) !important;
}
</style>
 